import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { createAdmin } from "helpers/requests";
import swal from 'sweetalert';

const CreateAdmin = (props) => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    role: "OPERATOR" // default role
  });

  useEffect(() => {
    document.title = "Create Admin";
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (formData.password !== formData.confirmPassword) {
      swal("Error", "Passwords do not match", "error");
      return;
    }

    // Prepare data for submission (remove confirmPassword)
    const { confirmPassword, ...submitData } = formData;

    try {
      await createAdmin(submitData);
      
      swal({
        title: "Success",
        text: "Admin created successfully!",
        icon: "success",
        button: "OK",
      }).then(() => {
        // Redirect to the admin list page
        window.location.href = "/admins";
      });
      
      // Reset form data after successful submission
      setFormData({
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
        role: "OPERATOR"
      });
    } catch (error) {
      console.error("Error creating admin:", error);
      
      // Check if error response exists and has a message
      const errorMessage = error.response?.data?.message || 
                           error.message || 
                           "Could not create admin. Please try again.";
      
      swal("Error", errorMessage, "error");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs 
            title={props.t("Create Admin")} 
            breadcrumbItem={props.t("Add New Admin")} 
          />

          <Row className="justify-content-center">
            <Col lg={6}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">{props.t("Create New Admin")}</CardTitle>
                  
                  <form onSubmit={handleFormSubmit}>
                    <FormGroup>
                      <Label for="username">{props.t("Username")}</Label>
                      <Input
                        type="text"
                        id="username"
                        name="username"
                        value={formData.username}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter username"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label for="email">{props.t("Email")}</Label>
                      <Input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter email address"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label for="password">{props.t("Password")}</Label>
                      <Input
                        type="password"
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter password"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label for="confirmPassword">{props.t("Confirm Password")}</Label>
                      <Input
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        required
                        placeholder="Confirm password"
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label for="role">{props.t("Admin Role")}</Label>
                      <Input
                        type="select"
                        id="role"
                        name="role"
                        value={formData.role}
                        onChange={handleInputChange}
                        required
                      >
                       
                        <option value="MODERATOR">Moderator</option>
                        <option value="SUPER">Super Admin</option>
                      </Input>
                    </FormGroup>

                    <Button color="primary" type="submit" className="mt-3 w-100">
                      {props.t("Create Admin")}
                    </Button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

CreateAdmin.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(CreateAdmin);